import React, { ReactNode } from "react";
import s from "./ComponentDescription.module.scss";

export interface IComponentDescription {
  name: string;
  description: string | ReactNode;
}

export function ComponentDescription({name, description}: IComponentDescription) {
  return <div className={s.container} id={"component_description"}>
    <div className={s.componentName}>{name}</div>
    <div className={s.componentDescription}>{description}</div>
  </div>
};